// Copyright (c) Docugami, Inc. All rights reserved.

import { TokenRange } from "networking/api";
import { Component, ComponentId } from "sdv/engine/Component";
import { Box } from "store/shared_types";

export interface RenderBox {
    box: Box;
    color?: string;
    strokeColor?: string;
    strokeWidth?: number;
}

export interface ChunkRenderComponent extends Component {
    bounds: Box[];
    containerBoxes: Box[];
    renderBoxes: RenderBox[];
    lastRange?: TokenRange;
}

export function createChunkRenderComponent(): ChunkRenderComponent {
    return {
        typeId: ComponentId.ChunkRender,
        bounds: [],
        containerBoxes: [],
        renderBoxes: []
    }
}
